<template>
  <div id="Jibenzoushi">
    <div class="tr-header">
      <p class="title">基本走势</p>
      <div class="handles" v-if="betType != 'xyrb'">
        <span
          @click="handleChecked('today', '0')"
          :class="{'checked': checked === '0'}"
          class="handle"
        >今天</span>
        <span
          @click="handleChecked('yesterday', '1')"
          :class="{'checked': checked === '1'}"
          class="handle"
        >昨天</span>
        <span
          @click="handleChecked('beforeYesterday', '2')"
          :class="{'checked': checked === '2'}"
          class="handle"
        >前天</span>
        <span
          @click="handleChecked('30', '3')"
          :class="{'checked': checked === '3'}"
          class="handle"
        >最近 30 期</span>
        <span
          @click="handleChecked('60', '4')"
          :class="{'checked': checked === '4'}"
          class="handle"
        >最近 60 期</span>
        <span
          @click="handleChecked('90', '5')"
          :class="{'checked': checked === '5'}"
          class="handle"
        >最近 90 期</span>
      </div>
    </div>
    <div class="tr-table-container">
      <div class="check_box">
        <span>标注选择:</span>
        <CheckboxGroup v-model="showList" @on-change="checkAllGroupChange">
          <Checkbox label="yilou">遗漏</Checkbox>
          <Checkbox label="zhexian">折线</Checkbox>
          <Checkbox label="yifen">遗漏分成</Checkbox>
        </CheckboxGroup>
      </div>
      <Table width="100%" :columns="columns" :data="dataSource" border></Table>
    </div>
    <div class="tr-table-container">
      <Table width="100%" :columns="lostColumns" :data="lostList" border></Table>
    </div>
  </div>
</template>

<script>
import columns from "./columns";
import dayjs from "dayjs";
import format from "../../../helpers/format.js";

export default {
  name: "Jibenzoushi",
  data() {
    return {
      showList: ["yilou", "zhexian"],
      checked: "3",
      columns: [],
      lostColumns: [],
      pageSize: 30,
      dataSource: [],
      gameResult: [],
      lostList: [],
      ballList: null,
      divideList: []
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        // this.reset();
        this.getDate();
      }
    }
  },
  methods: {
    checkAllGroupChange() {
      var lostList = document.querySelectorAll(".lost_info");
      var canvas = document.querySelector(".cvs_container");
      var divide = document.querySelectorAll(".divide_lost_info");
      for (let i = 0; i < divide.length; i++) {
        const e = divide[i];
        e.parentNode.parentNode.classList.remove("lost_active");
      }
      if (!this.showList.includes("yilou")) {
        for (let i = 0; i < lostList.length; i++) {
          const e = lostList[i];
          e.style.display = "none";
        }
      } else {
        for (let i = 0; i < lostList.length; i++) {
          const e = lostList[i];
          e.style.display = "inline-block";
        }
      }
      if (!this.showList.includes("zhexian")) {
        canvas.style.display = "none";
      } else {
        canvas.style.display = "inline-block";
      }
      if (this.showList.includes("yifen")) {
        for (let i = 0; i < divide.length; i++) {
          const e = divide[i];
          e.parentNode.parentNode.classList.add("lost_active");
        }
      } else {
        for (let i = 0; i < divide.length; i++) {
          const e = divide[i];
          e.parentNode.parentNode.classList.remove("lost_active");
        }
      }
    },
    handleChecked(agt, index) {
      this.startDate = "";
      this.pageSize = "";
      this.checked = index;
      var year = dayjs().year();
      var month = ("00" + (dayjs().month() + 1)).slice(-2);
      var date = ("00" + dayjs().date()).slice(-2);
      if (agt == "today") {
        this.startDate = `${year}-${month}-${date}`;
      } else if (agt == "yesterday") {
        // date -= 1;
        date = ("00" + (date - 1)).slice(-2);
        this.startDate = `${year}-${month}-${date}`;
      } else if (agt == "beforeYesterday") {
        // date -= 2;
        date = ("00" + (date - 2)).slice(-2);
        this.startDate = `${year}-${month}-${date}`;
      } else if (agt == "30") {
        this.pageSize = 30;
      } else if (agt == "60") {
        this.pageSize = 60;
      } else if (agt == "90") {
        this.pageSize = 90;
      }
      this.getDate();
    },
    reset(data) {
      this.columns = columns(this.betType, data).list(this);
      this.lostColumns = columns(this.betType, data).lostList(this);
    },
    formatLostList(arr) {
      this.divideList = arr[0].ball_json;
    },
    async getDate() {
      let req = {
        gameType: this.$route.params.gameType,
        isNeed: 1,
        num: this.pageSize,
        date: this.startDate
      };
      let gameLost = await this.$http.post("/queryKcReportByIssue.do", req);

      if (gameLost.data.returnCode == "0000") {
        this.formatLost(gameLost.data.returnMap);
        // this.ballList = gameLost.data.returnMap.balllist.split(",");

        var arrCopy = format.formatJson(gameLost.data.returnList);
        // console.log(gameLost.data.returnMap, "arrCopy");
        // arrCopy.ballList = arrCopy.balls.split(",");
        arrCopy.map(v => {
          v.ballList = v.balls.split(",");
        });
        console.log(arrCopy, "arrrrrrr");

        this.formatLostList(arrCopy);
        this.dataSource = arrCopy;
        this.reset(arrCopy);
        this.$nextTick(() => {
          window.scrollTo(0, 0);
          var canvas = document.querySelector(".cvs_container");
          let table = document.querySelector(".ivu-table-tbody");
          if (canvas) {
            table.removeChild(canvas);
          }
          this.createCanvas();
          this.checkAllGroupChange();
        });
      } else {
        this.$Message.error(gameLost.data.returnMessage);
      }
    },
    formatLost(arg) {
      var o = {
        allOpen: "出现次数", //出现次数
        // joinOpen: "当前连开",
        // averageOmit: "平均遗漏",
        maxOmit: "最大遗漏", //
        maxJoin: "最大连出" //
        // nowOmit: "当前遗漏"
      };
      var ballJson = arg.ballJson;
      var arr = [];

      for (const key in o) {
        var obj = {};
        obj.name = o[key];
        obj.key = key;
        obj.lost = ballJson;
        arr.push(obj);
      }
      this.lostList = arr;
    },
    // 走势图
    createCanvas() {
      // let tableContent = document.querySelector(".tr-table-container");
      // let table = document.querySelector(".ivu-table-wrapper");
      let table = document.querySelector(".ivu-table-tbody");
      // let table_canvas = document.querySelector("#canvas_table");
      let tablePos = table.getBoundingClientRect();
      // console.log(tablePos, tableContent.getBoundingClientRect(), "tablePos");
      let tableleft = tablePos.left;
      let tabletop = tablePos.top;
      //设置画布
      let cvs = document.createElement("canvas");
      cvs.style.marginTop = -table.offsetHeight + "px";
      cvs.className = "cvs_container";
      cvs.height = table.offsetHeight; // 表格的高度等同画布高度
      cvs.width = table.scrollWidth; // 表格的高度等同画布高度

      var redList = document.querySelectorAll(".red");
      // let length = this.dataSource[0].issueResult.length; // 开奖球数 5  就是列数
      let length = this.dataSource[0].ballList.length; // 开奖球数 5  就是列数

      let redLength = redList.length; // 中奖号码球数 150

      let canvasArr = []; // 画笔坐标系
      for (let i = 0; i < length; i++) {
        canvasArr[i] = new Array();
        // console.log(i + 1, "iiii");
        // for (let j = 0; j < this.pageSize; j++) {
        for (let j = 0; j < this.dataSource.length; j++) {
          var num = i + length * j;
          let dom = redList[num];
          let pos = dom.getBoundingClientRect();
          let left = pos.left + dom.offsetHeight / 2;
          let top = pos.top + dom.offsetWidth / 2;
          let a = { left: left - tableleft, top: top - tabletop - 15 };
          canvasArr[i].push(a);
        }
      }
      for (let i = 0; i < canvasArr.length; i++) {
        let colors = {
          0: "#fba75e",
          1: "#1fa6e8",
          2: "#0abe02",
          3: "#8485fb",
          4: "#46bd94",
          5: "#e16baa",
          6: "#f2b653",
          7: "#628ef3",
          8: "#5ec642",
          9: "#f66d6d"
        };
        let color = colors[i];
        let cxt = cvs.getContext("2d"); // 画笔
        cxt.strokeStyle = color; // 颜色
        cxt.beginPath();
        let it = canvasArr[i];
        if (it.length > 0) {
          cxt.moveTo(it[0].left, it[0].top);
          for (let j = 0; j < it.length; j++) {
            cxt.lineTo(it[j].left, it[j].top);
            cxt.stroke();
          }
        }
      }
      table.append(cvs); // 将绘画好的走势图接入表格dom树
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Jibenzoushi/index.vue